import React, {Component} from "react";
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise';
import Group from "../../../Components/Group";
import './index.css';
import Hospital from "../../../Server/Hospital";
import Grid, {gridDateTime} from "../../../Components/Grid";
import {Tool} from "../../../App";
import Resource from "../../../Resource";
import Perms from '../../../Perms';

class PageReturnOrgProducts extends Component {
    constructor(props) {
        super(props);

        if (!Perms().REPORTS.VIEW_BLOOD_BANK_RETRIEVED_PRODUCTS)
            props.history.push(Resource.ROUTE.HOME);

        this.state = {
            grid: {
                columnDefs: [{
                    headerName: 'اطلاعات فرآورده',
                    children: [{
                        field: 'productNumber',
                        headerName: 'شماره فرآورد',
                        headerTooltip: 'شماره فرآورد',
                        checkboxSelection: true,
                        headerCheckboxSelection: true,
                        filter: 'agTextColumnFilter'
                    }, {
                        field: 'productTypeStr',
                        headerName: 'نوع فرآورده',
                        headerTooltip: 'نوع فرآورده'
                    }, {
                        field: 'productBloodGroupStr',
                        headerName: 'BGRh فرآورده',
                        headerTooltip: 'BGRh فرآورده',
                        cellClass: row => row.data.patientBloodGroupId !== row.data.productBloodGroupId ? 'red' : 'green'
                    }, {
                        field: 'productExpireDate',
                        headerName: 'زمان انقضا',
                        headerTooltip: 'زمان انقضا',
                        valueGetter: gridDateTime.bind(this, 'date'),
                        cellRenderer: gridDateTime.bind(this, 'date')
                    }]
                }, {
                    headerName: 'اطلاعات عودت دهنده',
                    children: [{
                        field: 'returnerFullName',
                        headerName: 'نام عودت دهنده',
                        headerTooltip: 'نام عودت دهنده'
                    }, {
                        field: 'returnReasonStr',
                        headerName: 'علت عودت',
                        headerTooltip: 'علت عودت'
                    }, {
                        field: 'returnDateTime',
                        headerName: 'زمان عودت',
                        headerTooltip: 'زمان عودت',
                        valueGetter: gridDateTime.bind(this, 'date'),
                        cellRenderer: gridDateTime
                    }]
                }],
                help: _ => {
                    return <div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>رنگ‌ها:</h3>
                                <p className={'help-back-gre mar-b-4'}>نشان دهنده گروه خونی فرآورده می باشد.</p>
                            </div>
                        </div>
                    </div>;
                }
            },
            rowData: [],
            returnProductGrid: null
        };

        this.ref = {
            returnProductGrid: React.createRef()
        };
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return this.state.grid !== nextState.grid ||
            this.state.rowData !== nextState.rowData;
    }

    componentDidMount() {
        const {state, props} = this;

        const grid = Tool.applyGridDefaultSettings(props.gridDefaultSettings, state.grid);

        if (grid) {
            this.setState({grid});
        }
    }

    render() {
        return <React.Fragment>
            <Group className={'PageReturnOrgProducts-group mar-10'} title={'فرآورده‌های عودت شده به سازمان'} description={'لیست مربوط به فرآورده‌های عودت شده به سازمان از این قسمت قابل مشاهده و خروجی گیری می باشد.'}>
                <Grid  refer={this.ref.returnProductGrid} id={'returnToOrgProducts'} {...this.state.grid} rowData={this.state.rowData} onGridReady={this.gridReadyHandler.bind(this)}/>
            </Group>
        </React.Fragment>;
    }

    updateGrid() {
        this.ref.returnProductGrid.current.loading();

        Hospital.returnToOrgList()
            .then(list => {
                this.setState({rowData: list}, _ => {
                    this.ref.returnProductGrid.current.loading(false);
                });
            })
            .catch(message => {
                this.ref.returnProductGrid.current.error();
            });
    }

    gridReadyHandler(params) {
        this.updateGrid();

        this.setState({returnProductGrid: params});
    }
}

export default PageReturnOrgProducts